// import type { FC } from 'react';
import './handbook-completion-description.css'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';
const HandbookCompletionDescription = ({ description, isPopup }) => {
  const getOptions = () => {
    return {
      renderNode: {
        [INLINES.HYPERLINK]: ({ data }, children) => {
          return (
            <a href={data.uri} target="_blank" className="my-ap-link">
              {children}
            </a>
          );
        },
      },
    };
  };

  //SHOWING DESCRIPTION
  function ShowInputDescription(description) {
    return (
      <div className={!isPopup ? 'description' : ''} >
        {documentToReactComponents(description, getOptions())}
      </div>
    );
  }

  return <>{description && ShowInputDescription(description)}</>;
};

export default HandbookCompletionDescription;
